import styled from 'styled-components';
import THEME from '../../../constants/theme';

export const L12UM = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-transform: uppercase;
  color: ${({ color }) => color || THEME.greyColors.grey2};
  margin: ${({ margin }) => margin || '1em'};
`;
